// extracted by mini-css-extract-plugin
export var borderBottom = "Heading-module--borderBottom--luuQN";
export var cyan = "Heading-module--cyan--i1mSn";
export var fill = "Heading-module--fill--7wtvl";
export var h1 = "Heading-module--h1--f3arN";
export var h2 = "Heading-module--h2--BiSQK";
export var h3 = "Heading-module--h3--g5H9-";
export var h4 = "Heading-module--h4--eV0cc";
export var h5 = "Heading-module--h5--JdOgL";
export var h6 = "Heading-module--h6--6pxSA";
export var orange = "Heading-module--orange--PftRq";
export var pink = "Heading-module--pink--UGqzI";
export var purple = "Heading-module--purple--iSUDN";
export var red = "Heading-module--red--2Aiqz";
export var root = "Heading-module--root--6foSt";